import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPost, apiPut } from 'api-service';
import { toast } from 'lib';
import translation from 'translation';
import { companyAdapter } from './company.adapters';

const { t } = translation;

export const fetchCompanies = createAsyncThunk(
  'companyReducer/fetchCompanies',
  async (params = {}, thunkAPI) => {
    const { settingsReducer } = thunkAPI.getState();
    try {
      const response = await apiGet('/user/admin/company-info', {
        page: 1,
        count:
          settingsReducer?.filters?.public?.pageContentCountSlider
            ?.selectedValue,
        ...params,
      });

      return {
        companies: response.data?.result?.data?.map((company) =>
          companyAdapter(company)
        ),
        total: response.data?.result?.meta?.total,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchCompanyById = createAsyncThunk(
  'companyReducer/fetchCompanyById',
  async ({ companyId }, thunkAPI) => {
    try {
      const response = await apiGet(`/user/admin/company-info/${companyId}`);

      return companyAdapter(response.data?.result?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addNewCompany = createAsyncThunk(
  'companyReducer/addNewCompany',
  async (params = {}, thunkAPI) => {
    try {
      const response = await apiPost('/user/admin/company-info', params);
      toast({
        title: t('common:successOperation'),
        description: t('companies:success.addNewCompany.description'),
      });
      return response.data?.result?.data;
    } catch (error) {
      toast({
        type: 'error',
        title: t('common:errorOperation'),
        description: t('companies:error.addNewCompany.description'),
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const editCompany = createAsyncThunk(
  'companyReducer/editCompany',
  async ({ companyId, params }, thunkAPI) => {
    try {
      const response = await apiPut(
        `/user/admin/company-info/${companyId}`,
        params
      );
      toast({
        title: t('common:successOperation'),
        description: t('companies:success.editCompany.description'),
      });
      return response.data?.result?.data;
    } catch (error) {
      toast({
        type: 'error',
        title: t('common:errorOperation'),
        description: t('companies:error.editCompany.description'),
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);
